import React, { useState, useRef, useEffect } from 'react'

import { Spin, Input } from 'antd'
import '../../styles/_index.scss'
import moment from 'moment'
import UseDebounce from '../../../users/helpers/UseDebounce'

function QCHTQuantityStatisticsTable(props) {
    const tableRef = useRef()
    const columnRef = useRef()
    const inputRef = useRef(null)
    const { loading, list = [], total: currentTotal, totalWithTimeSlot: currentTotalWithTimeSlot = {}, newFilter } = props
    const [loadingList, setLoadingList] = useState(false)
    const [newList, setNewList] = useState(Array.isArray(list) ? list : [])
    const [searchUser, setSearchUser] = useState('')
    const [total, setTotal] = useState(currentTotal)
    const [totalWithTimeSlot, setTotalWithTimeSlot] = useState(currentTotalWithTimeSlot)

    const debounceSearchUser = searchUser === '' ? UseDebounce(searchUser, 0) : UseDebounce(searchUser, 500)

    useEffect(() => {
        setSearchUser('')
        setNewList(list)
        setTotal(currentTotal)
        setTotalWithTimeSlot(currentTotalWithTimeSlot)
    }, [list, currentTotal, currentTotalWithTimeSlot])

    const timeOptions = [
        '0h-1h', '1h-2h', '2h-3h', '3h-4h',
        '4h-5h', '5h-6h', '6h-7h', '7h-8h',
        '8h-9h', '9h-10h', '10h-11h', '11h-12h',
        '12h-13h', '13h-14h', '14h-15h', '15h-16h',
        '16h-17h', '17h-18h', '18h-19h', '19h-20h',
        '20h-21h', '21h-22h', '22h-23h', '23h-0h',
    ]
    const checkPeriod = (value) => {
        const currentTime = moment()
        if (newFilter.mark_QCHT_date === currentTime.format('YYYY-MM-DD')) {

            const [startTime, endTime] = value.split('-')
            if (currentTime.isBetween(moment(startTime, 'HH'), moment(endTime, 'HH'))) return 'PeriodSelect'

        }
    }
    const handleScroll = () => {
        const th1 = document.querySelector('th:first-child')
        const th2 = document.querySelector('th:nth-child(2)')
        const tbody = document.querySelector('tbody')
        const listBodyRow = tbody.querySelectorAll('tr')

        listBodyRow.forEach(i => {
            const td2 = i.querySelector('td:nth-child(2)')
            if (th1 && td2) {
                td2.style.left = th1.getBoundingClientRect().width + 'px'
            }
        })

        if (th1 && th2) {
            th2.style.left = th1.getBoundingClientRect().width + 'px'
        }
    }


    useEffect(() => {
        const table = columnRef.current
        handleScroll()
        if (table) {
            const currentTimeCol = table.querySelector('.PeriodSelect')
            const firstTimeCol = table.querySelector('.PeriodTime')
            if (currentTimeCol) {
                currentTimeCol.scrollIntoView({ block: 'nearest', inline: 'end' })
            } else {
                firstTimeCol.scrollIntoView({ block: 'nearest', inline: 'end' })
            }
        }
    }, [newFilter, newList])

    const handleChangeInput = async (field, e) => {
        const value = e.target.value
        if (field === 'searchUser') {
            setSearchUser(value)
        }
    }

    const filterList = async () => {
        setLoadingList(true)
        try {
            if (!!searchUser) {
                const query = searchUser.trim().toLowerCase()
                const newListFiltered = await (Array.isArray(list) && list.length > 0 ? list.filter(item =>
                    item.user_qcht.toLowerCase().includes(query)
                ) : [])
                const newSum = await newListFiltered.reduce((acc, cur) => acc + (cur.total || 0), 0)
                const aggregated = await newListFiltered.reduce((acc, item) => {
                    const slots = item.time_slot || {}
                    for (const [slot, val] of Object.entries(slots)) {
                        acc[slot] = (acc[slot] || 0) + (Number(val) || 0)
                    }
                    return acc
                }, {})
                setNewList(newListFiltered)
                setTotal(newSum)
                setTotalWithTimeSlot(aggregated)
                return
            }
            setNewList(list)
            setTotal(currentTotal)
            setTotalWithTimeSlot(currentTotalWithTimeSlot)
        } catch (error) {
            console.log(error.message)
        } finally {
            setLoadingList(false)
            if (inputRef.current) {
                inputRef.current.focus()
            }
        }
    }

    useEffect(() => {
        filterList()
    }, [debounceSearchUser])

    return (
        <Spin spinning={loading || loadingList} tip='Đang tải...' ref={tableRef} onScroll={handleScroll}>
            <table className='table table-bordered table-striped QCHTQuantityStatisticsTable' ref={columnRef} id='ExportTable'>
                <thead className='thead-light'>

                    <tr>
                        <th className='text-center' rowSpan={2} style={{ background: '#305496', color: 'white', minWidth: 150 }}>
                            <p>USER</p>
                        </th>
                        <th className="text-center" rowSpan={2} style={{ background: '#305496', color: 'white', minWidth: '100px' }}>
                            <p>TỔNG</p>
                        </th>
                        <th className="text-center" colSpan={24} style={{ background: '#305496', color: 'white' }}> THỜI GIAN</th>
                    </tr>
                    <tr>
                        {!!timeOptions.length && timeOptions.map((i, index) => (
                            <th key={index} className={`text-center PeriodTime ${checkPeriod(i)}`} style={{ background: '#8ea9db', color: 'white' }}>{i}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {!!newList && newList.length > 0 &&
                        <tr>
                            <td className='font-weight-bold text-center'>
                                <Input
                                    allowClear
                                    placeholder='Search user...'
                                    onChange={(e) => handleChangeInput('searchUser', e)}
                                    value={searchUser || ''}
                                    style={{ minWidth: 150 }}
                                    ref={inputRef}
                                />
                            </td>
                            <td className='font-weight-bold text-center'>{total || '-'}</td>
                            {!!timeOptions.length && timeOptions.map((i, index) => (
                                <td key={index} className={`text-center font-weight-bold ${checkPeriod(i)}`}>{!!totalWithTimeSlot ? totalWithTimeSlot[i] || '-' : '-'}</td>
                            ))}
                        </tr>
                    }
                    {
                        !!newList && newList.length > 0 ? (
                            newList.map((item, index) => (
                                <tr key={index}>
                                    <td className='text-center'>{item.user_qcht || '-'}</td>
                                    <td className='font-weight-bold text-center'>{item.total || '-'}</td>
                                    {!!timeOptions.length && timeOptions.map((i, index) => (
                                        <td key={index} className={`text-center ${checkPeriod(i)}`}>
                                            {
                                                item.time_slot && Object.keys(item.time_slot).length > 0 && item.time_slot[i] ? item.time_slot[i] : '-'
                                            }
                                        </td>
                                    ))}
                                </tr>
                            )
                            )

                        ) : (
                            <tr>
                                <td className='font-weight-bold text-center'>
                                    <Input
                                        allowClear
                                        placeholder='Search user...'
                                        onChange={(e) => handleChangeInput('searchUser', e)}
                                        value={searchUser || ''}
                                        style={{ minWidth: 150 }}
                                        ref={inputRef}
                                    />
                                </td>
                                <td>No data</td>
                                <td colSpan={24} className='text-center'>No data</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </Spin>
    )
}

export default QCHTQuantityStatisticsTable